const THIRD_PARTY_LOGIN_PAYLOAD_STORAGE_KEY = 'wikibit.thirdPartyLoginPayload.v1'
const THIRD_PARTY_REGISTRATION_PAYLOAD_STORAGE_KEY = 'wikibit.thirdPartyRegistrationPayload.v1'
export const THIRD_PARTY_REGISTRATION_EVENT = 'wikibit:third-party-registration'

const isThirdPartyLoginPayload = (payload: unknown): payload is Record<string, any> => {
  return payload !== null && typeof payload === 'object' && !Array.isArray(payload)
}

/**
 * 暂存第三方回调返回的登录数据，避免把 LoginToken 等完整 payload 放进 URL。
 */
export const writeThirdPartyLoginPayload = (payload: Record<string, any>) => {
  if (!import.meta.client) return false

  try {
    sessionStorage.setItem(THIRD_PARTY_LOGIN_PAYLOAD_STORAGE_KEY, JSON.stringify(payload))
    return true
  } catch {
    return false
  }
}

/**
 * 读取并清理第三方登录中间页的一次性 payload。
 */
export const takeThirdPartyLoginPayload = () => {
  if (!import.meta.client) return null

  try {
    const payload = sessionStorage.getItem(THIRD_PARTY_LOGIN_PAYLOAD_STORAGE_KEY)
    sessionStorage.removeItem(THIRD_PARTY_LOGIN_PAYLOAD_STORAGE_KEY)
    if (!payload) return null

    const parsedPayload: unknown = JSON.parse(payload)
    return isThirdPartyLoginPayload(parsedPayload) ? parsedPayload : null
  } catch {
    sessionStorage.removeItem(THIRD_PARTY_LOGIN_PAYLOAD_STORAGE_KEY)
    return null
  }
}

/** 暂存未注册第三方身份，避免在当前页 URL 中暴露账号标识和授权 token。 */
export const writeThirdPartyRegistrationPayload = (payload: Record<string, any>) => {
  if (!import.meta.client) return false

  try {
    sessionStorage.setItem(THIRD_PARTY_REGISTRATION_PAYLOAD_STORAGE_KEY, JSON.stringify(payload))
    window.dispatchEvent(new Event(THIRD_PARTY_REGISTRATION_EVENT))
    return true
  } catch {
    return false
  }
}

/** 判断当前页面是否有待处理的第三方邮箱绑定身份。 */
export const hasThirdPartyRegistrationPayload = () => {
  if (!import.meta.client) return false

  try {
    return Boolean(sessionStorage.getItem(THIRD_PARTY_REGISTRATION_PAYLOAD_STORAGE_KEY))
  } catch {
    return false
  }
}

/** 一次性读取第三方绑定邮箱流程需要的身份数据。 */
export const takeThirdPartyRegistrationPayload = () => {
  if (!import.meta.client) return null

  try {
    const payload = sessionStorage.getItem(THIRD_PARTY_REGISTRATION_PAYLOAD_STORAGE_KEY)
    sessionStorage.removeItem(THIRD_PARTY_REGISTRATION_PAYLOAD_STORAGE_KEY)
    if (!payload) return null

    const parsedPayload: unknown = JSON.parse(payload)
    return isThirdPartyLoginPayload(parsedPayload) ? parsedPayload : null
  } catch {
    sessionStorage.removeItem(THIRD_PARTY_REGISTRATION_PAYLOAD_STORAGE_KEY)
    return null
  }
}
